// Affiliate Links
export const RORK_AFFILIATE_LINK = "https://rork.com/?ref=toolmatch";
export const LOVABLE_AFFILIATE_LINK = "https://lovablelabs.pxf.io/aNLPgR";

// Contact
export const CONTACT_EMAIL = "contact@toolmatch.co";
